import styled from '@emotion/styled'

import Image from '@segment/matcha/components/Image'

import PropCardCtaPng2x from './assets/PropCardCta@2x.png'
import PropCardCtaWebp from './assets/PropCardCta.webp'
import PropCardCtaWebp2x from './assets/PropCardCta@2x.webp'

const PropCardCtaImage = () => {
  return (
    <Picture>
      <source type="image/webp" srcSet={`${PropCardCtaWebp}, ${PropCardCtaWebp2x} 2x`} />
      <StyledImage
        src={PropCardCtaPng2x}
        alt="Guide: Why Every Fintech Business Needs a CDP"
        width="640"
        height="469"
        loading="lazy"
      />
    </Picture>
  )
}

export default PropCardCtaImage

const Picture = styled.picture`
  display: flex;
  align-items: center;
`

const StyledImage = styled(Image)`
  max-width: 200px;

  ${({ theme }) => theme.breakpoints.up(`sm`)} {
    max-width: 250px;
  }
`
